import { z } from "zod/v4";
import { newsletterSchema } from "../schemas/newsletter";
import { fetchApi, fetchVoid } from "./internal";

export const newsletters = {
	list: (clubId: string) => fetchApi(`/clubs/${clubId}/newsletters`, z.array(newsletterSchema)),
	get: (clubId: string, nlId: string) =>
		fetchApi(`/clubs/${clubId}/newsletters/${nlId}`, newsletterSchema),
	create: (clubId: string, data: unknown) =>
		fetchApi(`/clubs/${clubId}/newsletters`, newsletterSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	update: (clubId: string, nlId: string, data: unknown) =>
		fetchApi(`/clubs/${clubId}/newsletters/${nlId}`, newsletterSchema, {
			method: "PUT",
			body: JSON.stringify(data),
		}),
	delete: (clubId: string, nlId: string) =>
		fetchVoid(`/clubs/${clubId}/newsletters/${nlId}`, { method: "DELETE" }),
	send: (clubId: string, nlId: string) =>
		fetchApi(`/clubs/${clubId}/newsletters/${nlId}/send`, newsletterSchema, {
			method: "POST",
		}),
};
